/**
 * Which page is framing us, for the video audit trail.
 *
 * ⚠️ The server cannot work this out for itself, and that is the reason this exists. The
 * embed page is served from the app's own origin, so its fetches to /api are SAME-ORIGIN:
 * the Origin header is our own origin and Referer is the embed URL. Neither describes the
 * site doing the framing. Only the framed document can see its own ancestors.
 *
 * `location.ancestorOrigins` is the precise answer but is Chrome/Safari-only.
 * `document.referrer` is the portable fallback and is subject to the parent page's referrer
 * policy, so it can be empty. Either way the value is self-reported and trivially
 * spoofable — the server stores it as a hint and authorises nothing off it.
 *
 * Lives in lib/ rather than beside the embed page because both Embed.jsx and VideoPlayer.jsx
 * need it, and Embed already imports VideoPlayer — putting it in either would be a cycle.
 */
export function framedBy() {
  try {
    const anc = window.location.ancestorOrigins;
    if (anc && anc.length) return anc[anc.length - 1];
    if (window.self !== window.top && document.referrer) return document.referrer;
  } catch { /* cross-origin access denied — nothing to report */ }
  return '';
}
